import PropTypes from 'prop-types';

export default PropTypes.shape({
    n: PropTypes.number,
    io: PropTypes.shape({
        totalBytes: PropTypes.number,
        currentBytes: PropTypes.number,
    }),
    cpu: PropTypes.shape({
        cpuPercentage: PropTypes.number,
        totalUsageInUserMode: PropTypes.number,
        currentUsageInUserMode: PropTypes.number,
        totalUsageInKernelMode: PropTypes.number,
        availableSystemCpuUsage: PropTypes.number,
        currentUsageInKernelMode: PropTypes.number,
    }),
    date: PropTypes.string,
    meta: PropTypes.shape({
        sample: PropTypes.number,
        container: PropTypes.string,
    }),
    time: PropTypes.number,
    active: PropTypes.bool,
    memory: PropTypes.shape({
        usage: PropTypes.number,
    }),
    network: PropTypes.shape({
        totalReceived: PropTypes.number,
        currentReceived: PropTypes.number,
        totalTransmitted: PropTypes.number,
        currentTransmitted: PropTypes.number,
    }),
    userTime: PropTypes.number,
});
